import { Stack, AnimationStyles, Text } from "@fluentui/react"
import { useSelector } from "react-redux"
import { IStore } from "../../../../../../core/store"
import { strings } from "../../../../../../localization/strings"
import { StagePreview } from "../../preview/StagePreview"
import { ProcessStages } from "@piceasoft/core"

export const IdentificationPreview: React.FC = () => {

    const config = useSelector((s: IStore) => s.configurator.identification)

    return (
        <StagePreview config={config}
            stage={ProcessStages.Identification}
            defaultNextText={strings.CONSTRUCTOR.STAGES.COMMON.TRANSACTION.CONTINUE}
            defaultCancelText={strings.CONSTRUCTOR.STAGES.COMMON.TRANSACTION.CANCEL}
            defaultStageTitle={strings.CONSTRUCTOR.STAGES.COMMON.TRANSACTION.IDENTIFICATION}
        >
            <Stack tokens={{ childrenGap: 32, padding: 32 }} styles={{ root: { ...AnimationStyles.slideUpIn10 } }} >
                <Stack.Item>
                    <Stack horizontalAlign="center" tokens={{ childrenGap: 8 }}>
                        <Text variant="xLarge" style={{ fontWeight: "bold" }}>{config.ui?.header ?? strings.CONSTRUCTOR.STAGES.IDENTIFICATION.HEADER}</Text>
                        <Stack tokens={{ maxWidth: 800 }}>
                            <div style={{ textAlign: "center" }}>
                                <Text variant="small">
                                    <div dangerouslySetInnerHTML={{ __html: config.ui?.information ?? strings.CONSTRUCTOR.STAGES.IDENTIFICATION.INFORMATION }}></div>
                                </Text>
                            </div>
                        </Stack>
                    </Stack>
                </Stack.Item>
            </Stack>
        </StagePreview>
    )
}